var pathName = location.pathname;

if(pathName == '/') {
  var container = document.querySelector('.f-External .js-Instagram ul');
  var phpFile = "/wp-content/themes/bbs2017/instagram.php";
} else if(pathName == '/gallery') {
  var container = document.querySelector('.js-Gallery');
  var phpFile = "/wp-content/themes/bbs2017/instagram_gallery.php";
}


if(container) {
  var html = "";
  var request = new XMLHttpRequest();
  request.open('POST', phpFile, true);
  request.onload = function(){
    var requestObj = JSON.parse(this.responseText);
    if(request.readyState === 4 ) {
      if(request.status === 200 ) {
        var instaData = requestObj.media.data;

        var count = 0;
        for(var i = 0, len = instaData.length; i < len; i++) {
          var imgurl = instaData[i].media_url;
          var link = instaData[i].permalink;
          var text = instaData[i].caption;

          if(instaData[i].media_type == 'IMAGE') {
            html += "<li><a href='" + link + "' target='_blank'><img src='" + imgurl + "'></a></li>";

            count++;
            if(count == 8) {
              break;
            }
          }

        }
        container.innerHTML = html;
      } else {
        html += '<li>No Images</li>';
      }
    }
  }
  request.send(null);
}